
import { config } from "@backstagex/core/src/config";

const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '診所名稱',
    model: 'name',
    placeholder: '診所名稱',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '診所代號',
    model: 'code',
    placeholder: '診所代號',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-select',
    label: '所屬院區',
    model: 'branch_id',
    required: true,
    help: "用於「關於禾馨 - 禾馨據點」",
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/hospital-branch-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'x-relationCheckBoxField',
    label: '所含科別',
    model: 'departments',
    required: true,
    values() {
      var xmlHttp = new XMLHttpRequest();
      xmlHttp.open("GET", config.apiHost + '/api/backstagex/' + this.$route.params.menuItemKey + '/hospital-department-list', false);
      xmlHttp.setRequestHeader('Authorization', 'Bearer ' + localStorage.token);
      xmlHttp.send();
      return JSON.parse(xmlHttp.responseText).data.data;
    },
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '地址',
    model: 'address',
    placeholder: '地址',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: 'Google Map 連結',
    model: 'google_map_url',
    placeholder: 'Google Map 連結',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '電話（1）',
    model: 'phone_1',
    placeholder: '電話（1）',
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '電話（2）',
    model: 'phone_2',
    placeholder: '電話（2）',
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-select",
    label: "網路掛號製造商",
    model: "manufacturer",
    required: true,
    values: [
      { id: "TECHGROUP", name: "TECHGROUP" },
      { id: "YANGMING_YIREN", name: "YANGMING_YIREN" },
      { id: "YANGMING_CENTER", name: "YANGMING_CENTER" },
      { id: "YIYUN", name: "YIYUN" },
    ],
    validator: function () {
      this.validation();
    },
  },
  {
    type: "x-QuillEditor",
    label: "看診時段",
    model: "time_info",
    help: "適用於網路掛號查詢「看診時段」",
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '網站連結',
    model: 'web_url',
    placeholder: '網站連結',
    validator: function () {
      this.validation();
    },
  },
  {
    type: "x-QuillEditor",
    label: "捷運",
    model: "traffic_metro",
    help: "適用於掛號查詢「交通資訊」",
  },
  {
    type: "x-QuillEditor",
    label: "公車",
    model: "traffic_bus",
    help: "適用於掛號查詢「交通資訊」",
  },
  {
    type: "x-QuillEditor",
    label: "開車",
    model: "traffic_drive",
    help: "適用於掛號查詢「交通資訊」",
  },
  {
    type: "x-QuillEditor",
    label: "停車地點",
    model: "parking_location",
    help: "適用於掛號查詢「交通資訊」",
  },
  {
    type: "bsx-input",
    inputType: "number",
    label: "排序權重",
    hint: "權重數字越大，排序越前；若數字相同，則 ID 越大，排序越前",
    model: "weight",
    placeholder: "排序權重",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '上架',
    textOff: '下架',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
];

export default fields;
